import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import PublicMondayIframe from '../component/PublicMondayIframe';

const PublicMondayIframePage = () => {
  const [searchParams] = useSearchParams();

  const feedId = useMemo(() => searchParams.get('feedId'), [searchParams]);
  const label = useMemo(() => searchParams.get('label') || 'Lunes', [searchParams]);
  const refreshInterval = useMemo(() => {
    const interval = searchParams.get('refreshInterval');
    return interval ? parseInt(interval) : 300000;
  }, [searchParams]);

  if (!feedId) {
    return (
      <div style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#000',
        color: '#fff',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}>
        <div style={{ textAlign: 'center' }}>
          <h1>⚠️ Parámetro faltante</h1>
          <p>Se requiere el parámetro <code>feedId</code> en la URL.</p>
          <p style={{ fontSize: '12px', color: '#999', marginTop: '16px' }}>
            Ejemplo: ?feedId=abc123&label=Mi%20Cámara
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <PublicMondayIframe
        feedId={feedId}
        label={label}
        refreshInterval={refreshInterval}
      />
    </div>
  );
};

export default PublicMondayIframePage;
